import { productImageStyle } from "../productImage";
import GroupSharedDirectory from "../components/GroupSharedDirectory";
import { ProductIcon } from "./productsRedesign";

/* Group catalogue — /overview/products. Every product across the group,
   one business at a time, plus the Global group (products marked
   `shared`). See GroupSharedDirectory for the data and write contracts. */


const SEARCH = ["product_name", "code", "product_type"];

function ProductCard(p, { isGlobal, ownerName }) {
  return (
    <>
      <span className="gp-thumb" style={productImageStyle(p, "thumb")}>
        {!p.image && <ProductIcon type={p.product_type} />}
        {p.code && <span className="gp-code">{p.code}</span>}
      </span>
      <span className="gp-item-body">
        <span className="gp-name">{p.product_name || "Untitled"}</span>
        <span className="gp-meta">
          <span className="gp-tag">{p.product_type || "No type"}</span>
          {isGlobal && (
            <span className="gp-owner" title="Created by">
              {ownerName}
            </span>
          )}
        </span>
      </span>
    </>
  );
}

export function GroupProductsPage() {
  return (
    <GroupSharedDirectory
      pageTitle="Group catalogue"
      heading="Products across the group"
      noun="product"
      nounPlural="products"
      fetchUrl="/group/products"
      listKey="products"
      countsKey="products"
      bulkUrl="/products/bulk"
      searchFields={SEARCH}
      searchPlaceholder="Search name, code or type"
      renderItem={ProductCard}
    />
  );
}

export default GroupProductsPage;
